import React from 'react';
import SectionOne from './SectionOne/index.jsx';

import './packageApl.scss';

export class PackageApplication extends React.Component {

    componentDidMount() {
        window.scrollTo(0,0)
    }


    render() {
        return (
            <React.Fragment>
                <section className="packageApl-component" >
                    <SectionOne  />
                </section>
            </React.Fragment>
        );
    }
}

export default PackageApplication;
